/**
 * Generated by orval v6.31.0 🍺
 * Do not edit manually.
 * Zäkra API 1.0
 * REST API for Zäkra
 * OpenAPI spec version: v1
 */

export type DirectionEnum = (typeof DirectionEnum)[keyof typeof DirectionEnum];

// eslint-disable-next-line @typescript-eslint/no-redeclare
export const DirectionEnum = {
  Ascending: 0,
  Descending: 1,
} as const;
